<div class="question-type__text">
  <h1 class="fs__xxl">AI Assisted Open Ended</h1>
  <p class="fs__md">
    Engages participants in an AI-driven conversation that dynamically adjusts questions based on previous answers. Ideal for creating an interactive
    experience.
  </p>
  <h2 class="fs__lg">Best Practices</h2>
  <ul class="question-type__bullet-points">
    <li class="fs__sm">
      <span class="text fw__500">Limit follow-up prompts</span>
      <span class="sub-text">Keep the follow-up prompts limited to prevent repetative questions.</span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Project brief</span>
      <span class="sub-text"
        >Ensure the project brief has sufficient information on what your research objectives are as it is used to aide the AI assistant in generating the
        follow-up questions.</span
      >
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Opening question</span>
      <span class="sub-text"
        >Make your opening question meaningful to the topic as it is used to aide the AI assistant in generating the follow-up questions.</span
      >
    </li>
  </ul>
</div>
